import { render } from "./Rent_process_delete_button .vue?vue&type=template&id=2260279e&scoped=true"
import script from "./Rent_process_delete_button .vue?vue&type=script&lang=js"
export * from "./Rent_process_delete_button .vue?vue&type=script&lang=js"

import "./Rent_process_delete_button .vue?vue&type=style&index=0&id=2260279e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2260279e"]])

export default __exports__